"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrepaidCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ButtonWithArrow_1 = require("../../components/ButtonWithArrow");
var Input_1 = __importDefault(require("../../components/Form/Input"));
var InfoDescription_1 = require("../../components/InfoDescription");
var Layout_1 = __importDefault(require("../Layout"));
var cards1_png_1 = __importDefault(require("../../static/img/png/cards1.png"));
var cards2_png_1 = __importDefault(require("../../static/img/png/cards2.png"));
var styles_1 = require("./styles");
var icons_1 = require("../../utils/icons");
var polished_1 = require("polished");
var window_size_1 = require("@react-hook/window-size");
var react_router_dom_1 = require("react-router-dom");
var arrayCards = [
    {
        icon: (0, jsx_runtime_1.jsx)(icons_1.IconSmallArchCyan, {}),
        arcColor: 'cyan',
        title: 'Empieza ahora mismo',
        paragraph: 'Todo lo que necesitas para inscribirte es una cuenta de Stripe, sin trámites ni garantía personal. Ponte en marcha en minutos con una tarjeta virtual.',
    },
    {
        icon: (0, jsx_runtime_1.jsx)(icons_1.IconSmallArchPurple, {}),
        arcColor: 'purple',
        title: 'Límites de crédito que crecen contigo',
        paragraph: 'Usamos tu historial bancario y de pagos para determinar tu límite de crédito. A medida que crece tu empresa, también crece tu línea de crédito.',
    },
    {
        icon: (0, jsx_runtime_1.jsx)(icons_1.IconSmallArchBlue, {}),
        arcColor: 'blue',
        title: 'Con el logotipo de tu marca',
        paragraph: 'Carga tu logotipo directamente desde el Dashboard para que tu tarjeta corporativa tenga el mismo estilo de tu marca.',
    },
    {
        icon: (0, jsx_runtime_1.jsx)(icons_1.IconSmallArchBlue, {}),
        arcColor: 'blue',
        title: 'Con el logotipo de tu marca',
        paragraph: 'Carga tu logotipo directamente desde el Dashboard para que tu tarjeta corporativa tenga el mismo estilo de tu marca.',
    },
];
function PrepaidCard(_a) {
    var sizeWidth = (0, window_size_1.useWindowWidth)();
    var navigation = (0, react_router_dom_1.useNavigate)();
    var _b = (0, react_1.useState)(''), fullName = _b[0], setFullName = _b[1];
    (0, react_1.useEffect)(function () {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);
    function handleGoToContact() {
        navigation("/contacts".concat(!!fullName ? "?n=".concat(fullName) : ''));
    }
    return ((0, jsx_runtime_1.jsx)(Layout_1.default, { children: (0, jsx_runtime_1.jsxs)(styles_1.Container, { children: [(0, jsx_runtime_1.jsx)(styles_1.ContainerOne, { children: (0, jsx_runtime_1.jsx)(styles_1.ContentOne, { children: (0, jsx_runtime_1.jsxs)(InfoDescription_1.InfoDescription, __assign({ tag: "", title: "Tarjeta Prepagada para empresas", maxWidthDescription: sizeWidth > 650 ? 475 : undefined, iconTag: (0, jsx_runtime_1.jsx)(icons_1.IconCard, {}), flexDirection: sizeWidth < 650 ? 'column' : 'row', rightComponent: (0, jsx_runtime_1.jsx)("img", { style: sizeWidth > 650
                                    ? {
                                        width: '100%',
                                        position: 'absolute',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        right: '-25%',
                                        zIndex: -1,
                                    }
                                    : { width: (0, polished_1.rem)(700) }, src: cards1_png_1.default }) }, { children: [(0, jsx_runtime_1.jsx)(styles_1.Paragraph, { children: "Son tarjetas personalizadas y desarrolladas especialmente para el segmento corporativo. Son recargables y aceptadas para realizar compras en todos los comercios donde acepten tarjetas, tanto f\u00EDsicas como virtuales." }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(Input_1.default, { label: "M\u00E1s informaci\u00F3n", name: "name", placeholder: "Escribe tu nombre y apellido", onChange: function (e) { return setFullName(e.target.value); } }), (0, jsx_runtime_1.jsx)(ButtonWithArrow_1.ButtonWithArrow, { style: {
                                        marginTop: '1rem',
                                        margin: '24px 0',
                                    }, label: "Contactar con ventas", onClick: handleGoToContact })] })) }) }), (0, jsx_runtime_1.jsx)(styles_1.ContainerTwo, { children: (0, jsx_runtime_1.jsx)(InfoDescription_1.InfoDescription, __assign({ tag: "", title: "\u00BFPor qu\u00E9 tener una tarjeta prepagada?", maxWidthDescription: 680 }, { children: (0, jsx_runtime_1.jsx)(styles_1.Paragraph, { children: "Nuestras tarjetas prepagadas son respaldadas por MasterCard, lo que permite que sean utilizadas en una gran variedad de establecimientos y tiendas virtuales." }) })) }), (0, jsx_runtime_1.jsx)(styles_1.ContainerFour, { children: (0, jsx_runtime_1.jsx)(styles_1.ContentOne, { children: (0, jsx_runtime_1.jsx)(InfoDescription_1.InfoDescription, __assign({ tag: "", 
                            // iconTag={<IconSmallCardPos />}
                            title: "Tenemos el tipo de tarjeta que necesitas", maxWidthDescription: sizeWidth > 650 ? 475 : undefined, flexDirection: sizeWidth < 650 ? 'column' : 'row', rightComponent: (0, jsx_runtime_1.jsx)("img", { style: sizeWidth > 650
                                    ? {
                                        height: '1200px',
                                        position: 'absolute',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        right: '-25%',
                                        zIndex: -1,
                                    }
                                    : { width: (0, polished_1.rem)(1000) }, src: cards2_png_1.default }) }, { children: (0, jsx_runtime_1.jsx)(styles_1.Paragraph, { children: (0, jsx_runtime_1.jsxs)("ul", { children: [(0, jsx_runtime_1.jsx)("li", { children: "Tarjeta de \u00DAnico Uso: Gift cards, tarjetas de Navidad, vales, etc." }), (0, jsx_runtime_1.jsx)("li", { children: "Tarjeta de Uso Frecuente: Tarjetas de beneficios para colaboradores, vi\u00E1ticos, alimentaci\u00F3n, de gasolina, etc." }), (0, jsx_runtime_1.jsx)("li", { children: "Tarjeta Tailor Made." })] }) }) })) }) })] }) }));
}
exports.PrepaidCard = PrepaidCard;
